module.exports = __webpack_public_path__ + "static/media/arrow-left.9604b13a.svg";